import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Spinner } from 'reactstrap';
import { WarningIcon } from '../svg/WarningIcon';
import '../500/styles.scss';

type OfflineProps = {
	onRetry: () => void;
};

export const Offline = ({ onRetry }: OfflineProps) => {
	const { t } = useTranslation('Common');
	const [retrying, setRetrying] = useState(false);
	const [countdown, setCountdown] = useState(15);

	useEffect(() => {
		const interval = setInterval(() => {
			setCountdown((prev) => {
				if (prev <= 1) {
					setRetrying(true);
					onRetry();
					return 15;
				}
				return prev - 1;
			});
		}, 1000);

		return () => clearInterval(interval);
	}, [onRetry]);

	useEffect(() => {
		if (retrying) {
			const timeout = setTimeout(() => setRetrying(false), 3000);
			return () => clearTimeout(timeout);
		}
	}, [retrying]);

	const handleManualRetry = () => {
		setRetrying(true);
		setCountdown(15);
		onRetry();
	};

	return (
		<div className="error-view">
			<h1 className="title">{t('No internet connection')}</h1>
			<div className="message">{t('Check your connection and try again.')}</div>
			<div style={{ marginBottom: '20px' }}>
				{retrying ? (
					<Spinner color="dark" size="sm" />
				) : (
					<>
						<Button color="primary" onClick={handleManualRetry}>
							{t('Retry now')}
						</Button>
						<div style={{ marginTop: '10px', color: '#888' }}>
							{t('Retrying automatically in {{seconds}}s', {
								seconds: countdown,
							})}
						</div>
					</>
				)}
			</div>
			<div className="image">
				<WarningIcon />
			</div>
		</div>
	);
};
